import React, { Component } from 'react'
import { connect } from 'react-redux'
import preload from 'components/enhancer/preload'
import { actions } from './redux'
import composeHOC from 'shared/utils/composeHOC'
import { Link } from 'react-router'
import Meta from 'components/layout/Meta';

class JobDetail extends Component {
  constructor(props) {
    super(props)
    this.needLeftNavigation = false
    this.state = {
      showShare: false,
      currentUrl: ''
    }

  }

  componentDidMount(){
    this.timer = null
    const currentUrl = encodeURIComponent(location.href)
    this.setState({
      currentUrl
    })
    //document.title=this.props.job.name+"_中腾信官网";
  }
  componentWillUnmount(){
    //document.title="中腾信贷款_无抵押个人小额贷款_信用贷款_消费贷款-中腾信官网";
  }

  showShare = () => {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    } else {
      this.setState({
        showShare: true
      })
    }
  }

  hideShare = () => {
    const me = this
    me.timer = setTimeout(function(){
      me.setState({
        showShare: false
      }, () => {
        clearTimeout(me.timer)
        me.timer = null
      })
    },100)
  }

  onApplyClick = () => {
    location.href='mailto:zhaopin.hr@chinatopcredit.com'
  }

  render() {
    const {
      name,
      department,
      publish_time,
      content
    } = this.props.job

    const {
      showShare
    } = this.state

    return(
      <div className="jobRecruitmentDetail">
        <Meta location={this.props.location} title="职位招聘-招贤纳士"/>
      <div className="jobDetailCon jobRecruitmentDetail">
        <div className="mg-auto area clearfix">
          <div className="jobDetailArea">
          <div className="jobDetailTitle">
            <h1 className="newsTitle-text">{name}</h1>
            <p>发布时间：
                  {publish_time}
            </p>
          </div>
          <div dangerouslySetInnerHTML={{__html: content}}>
          </div>
          <div className="shareCon clearfix">
            <ul className="clearfix">
              <li onClick={this.onApplyClick} className="popBtns applyBtn" >
                  申请该职位
              </li>
              <li className="popBtns" onMouseOver={this.showShare} onMouseOut={this.hideShare}>
                  分享该职位
                  <div className="popshare" style={{display: showShare ? 'block' : 'none'}}>
                    <a target="_blank" href="http://service.weibo.com/share/share.php?title=中腾信官网&amp;url=http://www.chinatopcredit.com/position/detail.htm%3Fid%3Dff80808159b5b333015af649cae000de&amp;appkey=2992571369&amp;pic=/images/fenxiang.jpg" title="新浪微博" className="sinashare">新浪微博</a>
                    <a target="_blank" href={`/qrCode?currentUrl=${this.state.currentUrl}`} title="微信分享" className="wxshare">微信分享</a>
                    <a target="_blank" href="http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=http://www.chinatopcredit.com/position/detail.htm%3Fid%3Dff80808159b5b333015af649cae000de&amp;title=中腾信官网&amp;pics=/images/fenxiang.jpg" title="QQ空间" className="QQshare">QQ空间</a>
                  </div>
              </li>
            </ul>
          </div>
          <p className="tips">* 注：邮件名请以“职位名+姓名”形式填写，简历及作品添加至附件</p>
          </div>
          </div>
      </div>
      </div>
    )
  }
}


export default composeHOC(
  connect(state => ({
    job: state.recruitment.job
  }), {
  }),
  preload(({dispatch, location, params}) => {
    return Promise.all([
      dispatch(actions.getJobDetail(params.id))
    ])
  })
)(JobDetail)



// WEBPACK FOOTER //
// ./modules/recruitment/JobDetail.js